<template>
  <div class="orders-page">
    <van-nav-bar
      title="我的已购"
      left-arrow fixed
      @click-left="$router.back()"
    />

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="— 没有更多了 —"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.id" class="order-card">
          <div class="order-main" @click="showExtractCode(item)">
            <div class="order-icon">
              <van-icon name="description-o" size="22" color="#6366f1" />
            </div>
            <div class="order-info">
              <div class="order-title">
                {{ item.resource ? item.resource.title : '资源已删除' }}
              </div>
              <div class="order-meta">
                <span>¥{{ item.actualAmount || item.amount }}</span>
                <span class="dot">·</span>
                <span>{{ formatDate(item.paidAt) }}</span>
              </div>
            </div>
          </div>
          <van-button
            size="small" round
            color="linear-gradient(135deg, #6366f1, #8b5cf6)"
            @click="showExtractCode(item)"
          >
            查看
          </van-button>
        </div>
      </van-list>
    </van-pull-refresh>

    <van-empty
      v-if="!loading && list.length === 0"
      image="search" description="还没有购买记录"
    />

    <!-- Extract code popup -->
    <van-popup v-model="showCode" position="bottom" round :style="{ height: 'auto' }">
      <div class="code-popup">
        <h3>网盘提取信息</h3>
        <div class="code-card">
          <div class="code-item">
            <span class="code-label">网盘链接</span>
            <span class="code-text link" @click="openLink(extractData.driveUrl)">
              {{ extractData.driveUrl }}
            </span>
          </div>
          <div class="code-item">
            <span class="code-label">提取码</span>
            <span class="code-text code-val">{{ extractData.extractCode }}</span>
            <van-button
              size="mini" round
              color="linear-gradient(135deg, #6366f1, #8b5cf6)"
              @click="copyText(extractData.extractCode)"
            >
              复制
            </van-button>
          </div>
        </div>
        <van-button
          round block
          color="linear-gradient(135deg, #6366f1, #8b5cf6)"
          @click="openLinkAndCopy(extractData.driveUrl, extractData.extractCode)"
        >
          打开网盘并复制提取码
        </van-button>
        <div class="code-cancel" @click="showCode = false">关闭</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { orderApi } from '../api';

export default {
  data() {
    return {
      list: [], page: 1, size: 10,
      loading: false, finished: false, refreshing: false,
      showCode: false, extractData: {}
    };
  },
  methods: {
    async onLoad() {
      const res = await orderApi.getMyOrders({ page: this.page, size: this.size });
      const data = res.data;
      this.list = this.page === 1 ? data.list : [...this.list, ...data.list];
      this.loading = false;
      if (this.list.length >= data.total) this.finished = true;
      this.page++;
    },
    async onRefresh() {
      this.page = 1; this.finished = false;
      this.loading = true;
      await this.onLoad();
      this.refreshing = false;
    },
    async showExtractCode(item) {
      const res = await orderApi.getExtractCode(item.id);
      this.extractData = res.data;
      this.showCode = true;
    },
    openLink(url) {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$toast.success('已复制');
      } catch (e) {
        const input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$toast.success('已复制');
      }
    },
    openLinkAndCopy(url, code) {
      this.copyText(code);
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }
  }
};
</script>

<style scoped>
.orders-page { min-height: 100vh; background: #f5f7fa; padding-top: 46px; }
.order-card {
  display: flex; align-items: center; justify-content: space-between;
  margin: 8px 16px; padding: 14px;
  background: #fff; border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.order-main {
  display: flex; align-items: center; gap: 12px;
  flex: 1; min-width: 0; cursor: pointer;
}
.order-icon {
  width: 42px; height: 42px; border-radius: 12px;
  background: #eef2ff; display: flex;
  align-items: center; justify-content: center; flex-shrink: 0;
}
.order-info { min-width: 0; }
.order-title {
  font-size: 15px; font-weight: 600; color: #1f2937;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.order-meta { font-size: 12px; color: #9ca3af; margin-top: 2px; }
.dot { margin: 0 4px; }

/* Popup */
.code-popup { padding: 24px 20px 16px; }
.code-popup h3 {
  text-align: center; margin: 0 0 16px;
  font-size: 18px; color: #1f2937;
}
.code-card {
  background: #f5f7fa; border-radius: 12px; padding: 12px;
  margin-bottom: 16px; border: 1px dashed #d1d5db;
}
.code-item {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 0; border-bottom: 1px solid #e5e7eb;
}
.code-item:last-child { border-bottom: none; }
.code-label { font-size: 13px; color: #9ca3af; flex-shrink: 0; }
.code-text {
  font-size: 13px; color: #1f2937; text-align: right; flex: 1; min-width: 0;
  word-break: break-all;
}
.code-text.link { color: #6366f1; text-decoration: underline; cursor: pointer; }
.code-text.code-val {
  font-size: 22px; font-weight: 700; color: #6366f1; letter-spacing: 6px;
}
.code-cancel {
  text-align: center; font-size: 14px; color: #9ca3af;
  padding: 12px 0 4px; cursor: pointer;
}
</style>
